import React from 'react';

/**
 * PaymentIcons — accepted payment methods for Stitch Your Dash.
 * NOTE: Discover is intentionally NOT included (not an accepted payment method).
 * We only accept Visa, Mastercard, and American Express.
 *
 * Renders accessible, self-contained card brand badges (no external image).
 */
const PaymentIcons = ({ size = 'md', className = '' }) => {
  const sizes = {
    sm: 'h-6 px-2 text-[10px]',
    md: 'h-8 px-2.5 text-[11px]',
    lg: 'h-10 px-3 text-[12px]',
  };
  const base = `inline-flex items-center justify-center font-bold tracking-wide rounded-md border ${sizes[size] || sizes.md}`;

  return (
    <div
      className={`flex items-center gap-2 ${className}`}
      role="img"
      aria-label="Accepted payment methods: Visa, Mastercard, and American Express"
    >
      {/* Visa */}
      <span className={`${base} bg-white border-slate-200`} style={{ minWidth: '46px' }}>
        <span className="font-display italic text-[#1A1F71]" style={{ letterSpacing: '0.05em' }}>VISA</span>
      </span>

      {/* Mastercard */}
      <span
        className={`${base} bg-white border-slate-200 relative overflow-hidden`}
        style={{ minWidth: '46px' }}
      >
        <span className="flex items-center">
          <span className="w-3.5 h-3.5 rounded-full bg-[#EB001B] -mr-1.5" />
          <span className="w-3.5 h-3.5 rounded-full bg-[#F79E1B] opacity-90" />
        </span>
      </span>

      {/* American Express */}
      <span
        className={`${base} bg-[#2E77BB] border-[#2E77BB] text-white`}
        style={{ minWidth: '46px' }}
      >
        <span className="font-bold tracking-tight">AMEX</span>
      </span>
    </div>
  );
};

export default PaymentIcons;
